<template>
  <div class="input-container">
    <input ref="input" multiple type="file" accept="image/*"  @change="loadFile">
    <div class="columns is-mobile container-min">
      <div class="column is-6">
        <t-button @click="searchImage()">{{titleButtonSearch}}</t-button>
      </div>
      <div class="column is-6">
        <t-button :disabled="imageSelected" @click="sendImage()" style="float:right" color="0f62ab">{{titleButtonSend}}</t-button>
      </div>
    </div>
    <p ref="fileInfo" class="file-info">Nenhuma imagem selecionada</p>
    <img ref="image" v-show="image" class="image" >
  </div>
</template>
<script>
import TButton from '@/components/TButton.vue'
import Notification from '@/support/mixins/notifications.mixin'
import EssayService from '@/services/essay/essay'
export default {
  props: {
    titleButtonSearch: {
      required: true
    },
    titleButtonSend: {
      required: true
    }
  },
  data () {
    return {
      image: false,
      file: '',
      imageSelected: true,
      themeId: this.$route.params.id,
      EssayService: new EssayService()
    }
  },
  components: {
    TButton
  },
  mixins: [Notification],
  methods: {
    searchImage () {
      this.$refs.input.click()
    },
    openImage (output) {
      this.image = true
      output.src = URL.createObjectURL(event.target.files[0])
    },
    closeImage () {
      this.image = false
    },
    loadFile (event) {
      this.file = event.target.files[0]
      const image = this.$refs.image
      image.src = ''
      this.file !== undefined ? this.openImage(image) : this.closeImage()
      this.imageIsSelected()
      this.generateNameImage()
    },
    generateNameImage () {
      const name = this.$refs.input.value.split(/\\|\//).pop()
      const truncated = name.length > 20 ? name.substr(name.length - 20) : name
      this.$refs.fileInfo.innerHTML = truncated
    },
    sendImage () {
      const essay = { essayImage: this.file, themeId: this.themeId }
      this.EssayService.sendEssayImage(essay).then((result) => {
        this.successMsg('Redação', 'Redação enviada ao corretor com sucesso', 'topCenter')
        this.clearValues()
      }).catch((error) => {
        this.erroMsg('Redação', error.message, 'topCenter')
      })
    },
    imageIsSelected () {
      this.imageSelected = false
    },
    imageIsNotSelected () {
      this.imageSelected = true
    },
    clearValues () {
      this.file = ''
      this.image = false
      this.$refs.fileInfo.innerHTML = 'Nenhuma imagem selecionada'
      this.imageIsNotSelected()
    }
  }
}
</script>
<style scoped>
.input-container {
  /* margin: 3em auto; */
  background-color: #ededed;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
}

input[type="file"] {
  display: none;
}

.file-info {
  font-size: 0.9em;
}
.image {
  width:100%
}
</style>
